/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';
import { PeriodModel } from './period.model';
const { model, string, number, identifierNumber, boolean, array } = types;

export const SubscriptionPlanModel = model('SubscriptionPlanModel', {
  id: identifierNumber,
  name: string,
  quantity: number,
  isTrial: boolean,
  status: number,
  periods: array(PeriodModel),
});

export type ISubscriptionPlanModel = Instance<typeof SubscriptionPlanModel>;
